import type { QueryItem, TimelineEvent } from "../../types/encounter-drg";
import { TYPE_BADGE } from "./theme";

export const PANEL_MAX_HEIGHT = "calc(100vh - 140px)";

export const formatDateTime = (value?: string | null) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatCurrency = (value?: string) => {
  if (!value) return "N/A";
  const normalized = Number.parseFloat(value.replace(/[^0-9.-]/g, ""));
  if (Number.isNaN(normalized)) return value;
  return normalized.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getSourceColor = (source: QueryItem["source"]) => {
  if (source === "CODING") return "yellow";
  if (source === "CDI") return "grape";
  return "gray";
};

export const getStatusColor = (status: string) => {
  const normalized = status.toUpperCase();
  if (normalized.includes("COMPLETE") || normalized.includes("RESOLVED"))
    return "green";
  if (normalized.includes("PENDING") || normalized.includes("OPEN"))
    return "orange";
  if (normalized.includes("ACK")) return "blue";
  return "gray";
};

export const getTypeBadgeStyle = (type: string) => {
  if (type === "MED") return TYPE_BADGE.MED;
  return TYPE_BADGE.SURG;
};

export const getTimelineUserText = (
  event: TimelineEvent,
  caseCreatedByEmail?: string | null,
) => {
  if (event.type === "CASE_CREATED") {
    return (
      caseCreatedByEmail ||
      event.userEmail ||
      event.email ||
      event.userId ||
      event.user
    );
  }

  return event.userEmail || event.email || event.userId || event.user;
};
